// extracted by mini-css-extract-plugin
export default {"business_service":"Service_business_service__TNYcC"};